/**
 * Structural route list. Title/description copy lives in the `seo.*` i18n
 * catalog (src/i18n/messages/<locale>.json) so it can be localized - this
 * file only maps a path to the catalog key and route type.
 */
export interface Route {
  path: string;
  /** Key under the `seo` namespace, e.g. "pro" -> seo.pro.title / seo.pro.description */
  seoKey: string;
  type: 'main' | 'blog' | 'destinations' | 'legal' | 'other';
}

export const BASE_URL = 'https://www.trycurrents.app'

export const routes: Route[] = [
  { path: '/', seoKey: 'home', type: 'main' },
  { path: '/pro', seoKey: 'pro', type: 'main' },
  { path: '/about', seoKey: 'about', type: 'main' },
  { path: '/research', seoKey: 'research', type: 'main' },
  { path: '/compatibility', seoKey: 'compatibility', type: 'main' },
  { path: '/privacy-policy', seoKey: 'privacyPolicy', type: 'legal' },
  { path: '/terms-of-service', seoKey: 'termsOfService', type: 'legal' },
  // Not locale-prefixed (blog stays English-only); kept here so SEO.tsx can
  // still resolve a default title/description for the blog listing page.
  { path: '/blog', seoKey: 'blog', type: 'blog' },
  // Destination guides: first-person, hand-written, English-only like the blog.
  { path: '/destinations', seoKey: 'destinations', type: 'destinations' },
];

export const getRoute = (path: string): Route | undefined => {
  return routes.find((route) => route.path === path);
};

export default { routes, getRoute, BASE_URL };
